import React from "react";
import PainelOperadoras from "./painelOperadoras";
import EstadoRequisicao from "../componentes/EstadoRequisicao";
import { useFiltroAba } from "../contexto/filtroHome";
import { useRequisicao } from "../hooks/useRequisicao";
import TabelaTransacoes from "../componentes/tabelaTransacoes";
import { FiltroHome, buscarPainel } from "../../../../services/home";

const Antecipacoes = () => {
  const filtro = useFiltroAba("ANTECIPADO");
  const { dados, carregando, erro, recarregar } = useRequisicao(
    () => buscarPainel("ANTECIPADO", filtro as FiltroHome),
    [filtro],
    Boolean(filtro)
  );

  return (
    <EstadoRequisicao carregando={carregando || !filtro} erro={erro} vazio={!!dados && dados.operadoras.length === 0} onRecarregar={recarregar}>
      {dados && (
        <PainelOperadoras
          titulo="Antecipações por operadora"
          operadoras={dados.operadoras}
          indicadores={dados.indicadores}
          detalhes={<TabelaTransacoes tipo="ANTECIPADO" filtro={filtro as FiltroHome} />}
        />
      )}
    </EstadoRequisicao>
  );
};

export default Antecipacoes;
